import { useGetStudiesListQuery } from '@/state/slices/studies';

// Every report status, so the list holds only studies that have a report.
const REPORT_STATUSES = ['DRAFT', 'PRELIMINARY', 'FINAL'];
const PAGE_SIZE = 20;

/** Studies a template can be previewed against: only those with a report. */
export function useReportStudies(search = '') {
  return useGetStudiesListQuery({
    size: PAGE_SIZE,
    report_status: REPORT_STATUSES,
    ...(search ? { search } : {}),
  });
}
